<template>
	<!-- 专业管理 -->
	<div class="mod-config">
		<!-- <el-col :span="1" style="border:1px solid transparent"></el-col> -->
		<el-col :span="24" style="margin-top:-10px">
			<el-card body-style="padding-bottom: 0;" style="margin-top: 5px;">
				<el-row class="title_color">
					<el-col :span="20">
						<div class="title">安全监督检查记录</div>
					</el-col>
					<el-col :span="4" style="margin-top:10px;margin-bottom:-10px">
						<i class="el-icon-sort" id="PointerIcon" style="right:1rem;transform:rotate(90deg);" @click="goBack()"></i>
						<el-button v-preventReClick type="text" @click="goBack()" class="backbtn">返回门户</el-button>
					</el-col>
				</el-row>
				<div class="line"></div>
				<el-row
					style="margin-top: -8px;margin-left: -20px;line-height:30px;width: 103%;background-color: rgb(243, 247, 247);">
					<el-row style="margin-top: 10px;">
						<el-col :span="2">
							<div class="search_title">标的物</div>
						</el-col>
						<el-col :span="22" style="display: flex;flex-wrap: wrap;">
							<span v-for="(subject, index) in subjectList" style="margin-right: 50px;">
								<span class="search_bn_border" v-if="subjectNo === subject.displayValue"
									@click="setSubject(subject)">
									{{ subject.displayName }}
								</span>
								<span class="search_bn" v-else-if="subjectNo !== subject.displayValue"
									@click="setSubject(subject)">
									{{ subject.displayName }}
								</span>
							</span>
						</el-col>
					</el-row>
					<!-- <div class="line"></div> -->
					<el-form ref="form" :model="form" inline label-width="80px" label-position="left">
						<el-row class="set_search">
							<el-col :span="12" style="margin-left:40px">
								<el-form-item label="报告名称" class="selFormItem">
									<el-input class="selSearchInput" type="input" v-model="fileName" placeholder="请输入内容"
										clearable></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10" class="selBtnGroup" style="margin-top:5px">
								<el-button v-preventReClick class="btn" type="primary" size="small"
									@click="selGetDataList()">查询</el-button>
								<el-button v-preventReClick class="rebtn" size="small" @click="resetFormData()">重置</el-button>
							</el-col>
						</el-row>
					</el-form>
				</el-row>
			</el-card>
			<el-row>
				<div>
					<el-card style="margin-top: -25px;" body-style="padding: 0;">
						<el-row style="margin-bottom: 10px;">
							<el-col :span="24">
								<div class="box">
									<el-table :height="screenHeight - 185 + 'px'" :row-class-name="tableRowClassName" :row-style="selectRowBackground"
										ref="dataListTable" class="dataListTable" :data="dataList" header-align="center" border
										:cell-style="{ padding: '0px' }" header-cell-class-name="dataListTHeader"
										style="margin-bottom: 20px;">
										<el-table-column type="index" label="NO." width="60" align="center">
											<template slot-scope="scope">{{ (pageIndex2 - 1) * pageSize + scope.$index + 1
											}}</template>
										</el-table-column>
										<el-table-column prop="fileName" label="文件名称" align="center">
											<template slot-scope="scope">
												<el-button v-preventReClick type="text" size="small"
													@click="viewPdf(scope.row.filePath, scope.row.filePathUrl, scope.row.fileName)">{{
														scope.row.fileName }}</el-button>
											</template>
										</el-table-column>
										<el-table-column prop="createTime" label="上传时间" align="center" width="200px">
										</el-table-column>
										<el-table-column prop="createMan" label="上传人" align="center" width="200px">
										</el-table-column>
										<el-table-column prop="remark" label="备注" align="center" width="300px">
										</el-table-column>
										<el-table-column label="操作" width="80" align="center">
											<template slot-scope="scope">
												<!-- <el-button v-preventReClick type="text" size="small"
													@click="updateHandle(scope.row.recId)">更新</el-button> -->
												<el-button v-preventReClick type="text" size="small"
													v-if="scope.row.filePathUrl != null"
													@click="downloadFile(scope.row.filePathUrl, scope.row.fileName)">下载</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>
								<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
									@current-change="currentChangeHandle" :current-page="pageIndex"
									:page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
									layout="total, sizes, prev, pager, next, jumper">
								</el-pagination>
							</el-col>
						</el-row>
					</el-card>
				</div>
			</el-row>
		</el-col>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf" @refreshDataList="dataList"></view-pdf>
	</div>
</template>
<script>
import $common from "@/utils/common.js"
import ViewPdf from "../projectInfo/viewPdf.vue"
export default {
	data() {
		return {
			viewPdfVisible: false,
			pageSpan: 12,
			addVisible: false,
			updateVisible: false,
			form: {},
			totalCount: 0,
			//当前页码
			pageIndex: 1,
			// 显示序号
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			dataList: [],
			fileName: '',
			disabledBatchDelete: true,
			tableSelVal: [],
			specialReportId: '',
			subjectNo: '',
			subjectList: [],
			screenHeight: 0
		};
	},
	components: {
		ViewPdf
	},
	mounted() {
		this.screenHeight = window.innerHeight
		this.getSubjectDropDown();
		// this.getDataList();
		this.pageIndex2 = 1;
	},
	methods: {
		//重置
		resetFormData() {
			this.fileName = '';
			this.pageIndex = 1;
			this.pageIndex2 = 1;
			this.getDataList();
		},
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.subjectList = data.body;
					if (this.subjectList != undefined && this.subjectList.length > 0) {
						this.subjectNo = this.subjectList[0].displayValue
						this.getDataList();
					}
				}
			});
		},
		viewPdf(filePath, fileUri, filename) {
			// pdf和doc文件，需要pdf在线预览，其他类型文件直接下载
			let suffixType = fileUri.substr(fileUri.lastIndexOf(".") + 1)
			if(suffixType != '' && (suffixType === 'pdf' || suffixType === 'doc' || suffixType === 'docx')) {
				// $common.viewFile(filePath)
				this.viewPdfVisible = true;
				this.$nextTick(() => {
					this.$refs.viewPdf.init(filename, filePath)
				})
			} else {
				filename = this.getSuffix(fileUri, filename)
				this.getBlob(fileUri, (blob) => {
					this.saveAs(blob, filename)
				})
			}
		},
		downloadFile(fileUri, filename) {
			filename = this.getSuffix(fileUri, filename)
			this.getBlob(fileUri, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		getSuffix(url, filename) {
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		//获取数据
		getDataList() {
			// 先获取安全监督检查记录目录的id
			this.$http({
				url: this.$store.state.httpUrl + "/business/filekindconfig/getFileKindConfigRecId",
				method: 'post',
				data: this.$http.adornData({
                    workNo: $common.getItem("workNo"),
					kindName: '安全监督检查记录',
                })
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.specialReportId = data.body
					this.$http({
						url: this.$store.state.httpUrl + "/business/projectworkfileinfo/getWorkFileListBySubjectNo",
						method: "get",
						params: {
							workNo: $common.getItem("workNo"),
							fileKind: this.specialReportId,
							fileName: this.fileName,
							limit: this.pageSize,
							page: this.pageIndex,
							subjectNo:this.subjectNo
							// type: 0
						},
					}).then(({ data }) => {
						if (data && data.code === 200) {
							this.dataList = data.body.records;
							this.totalPage = data.body.totalCount;
							this.pageIndex2 = this.pageIndex
						}
					});
				}
			})
		},
		selGetDataList() {
			this.pageIndex = 1;
			this.getDataList();
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVal.map((item) => item.recId);
			if (checkIdList.includes(row.recId)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
		setSubject(subject) {
			this.subjectNo = subject.displayValue
			this.getDataList()
		},
		goBack() {
			this.$router.push({ name: 'workbench' });
		}
	}
};
</script>
<style lang="scss" scoped="scoped">
.my-pagination {
	margin-left: 20px !important;
	margin-top: -10px !important;
}

::v-deep(.el-table th.el-table__cell) {
	// background-color: #d3e2f4 !important;
	font-size: 15px;
	padding: 2px 0;
}


::v-deep(.selSearchInput .el-input__inner) {
	width: 150px !important;
	height: 30px !important;
}

::v-deep(.selFormItem .el-form-item__label) {
	font-size: smaller;
}
</style>
